import * as z from "zod";

// Status strings are open (vendor §12.2) — kept as plain strings so an unknown
// value renders rather than failing validation. Declared here (not imported from
// the server-only client) to keep that client out of the browser SDK bundle.
const descriptorEntrySchema = z.object({
  value: z.string(),
  status: z.string(),
  reason: z.string().nullish(),
});

const binEntrySchema = z.object({
  id: z.string().nullish(),
  acquirerBin: z.string().nullish(),
  caid: z.string().nullish(),
  status: z.string(),
  reason: z.string().nullish(),
});

export const resolveStatusSchema = z.object({
  enrolled: z.boolean(),
  status: z.string().nullable(),
  descriptors: z.array(descriptorEntrySchema),
  bins: z.array(binEntrySchema),
  merchantName: z.string().nullish(),
  locale: z.string().nullish(),
});

// Live RESOLVE integration status (+ per-entry sub-statuses). `available:false`
// means the live read failed and the UI should degrade rather than blank.
export const getDisputelyResolveStatus = {
  name: "getDisputelyResolveStatus" as const,
  input: z.object({}),
  output: z.object({
    provisioned: z.boolean(),
    available: z.boolean(),
    resolve: resolveStatusSchema,
  }),
};
